import React from 'react'
import { Routes , Route} from 'react-router-dom'
import Layouts from './../Layouts/Layouts';
import Home from '../Pages/Home/Home';
import SubscriptionPack from '../Pages/SubscriptionPack/SubscriptionPack';
import ShoppingCart from '../Pages/Shop/ShoppingCart';
import Inscription from '../Pages/Register/Inscription';
import Login from '../Pages/Register/Login';


//Coté Dashboard
import ProtectedRoute from '../App/components/ProtectedRoute';
import Dashboard from '../App/Pages/Dashboard';
import LayoutCustomer from '../App/components/LayoutCustomer';
import CheckoutSubscription from '../Pages/SubscriptionPack/CheckoutSubscription';
import PaymentSuccess from '../Pages/StatusPayment/PaymentSuccess';
import PaymentFailure from '../Pages/StatusPayment/PaymentFailure';
import Checkout from '../Pages/Shop/Checkout';
import Orders from '../App/Pages/Orders/Orders';
import OrdersPack from '../App/Pages/OrdersPack/OrdersPack';
import OrdersFailed from '../App/Pages/Orders/OrdersFailed';
import SubscriptionCustomer from '../App/Pages/Subscription';
import SubscriptionFailed from '../App/Pages/SubscriptionFailed';
import ComptClient from '../App/Pages/ComptClient';
import OrdersLastMonth from '../App/Pages/Orders/OrdersLastMonth';
import OrdersActuelMonth from '../App/Pages/Orders/OrdersActuelMonth';
import OrdersPackActuelMonth from '../App/Pages/OrdersPack/OrdersPackActuelMonth';
import OrdersPackLastMonth from '../App/Pages/OrdersPack/OrdersPackLastMonth';
import ListAppointment from '../App/Pages/Appointment/ListAppointment';
import Apropos from '../Pages/Apropos/Apropos';
import Contact from '../Pages/Contact/Contact';
import OrderPackDetails from '../App/Pages/OrdersPack/OrderPackDetails';
import OrderDetails from '../App/Pages/Orders/OrderDetails';
import ListAppointmentInValid from '../App/Pages/Appointment/ListAppointmentInValid';
import ListAppointmentFailed from '../App/Pages/Appointment/ListAppointmentefailed';
import Course from '../Pages/Courses/Course';
import DashboardPage from '../Pages/Dashboard/DashboardPage';
import DetailsCourse from '../Pages/Courses/detailsCourse';
import HelpCenter from '../Pages/Apropos/HelpCenter';
import Condition from '../Pages/Condition/condition';
import PaymentPending from '../Pages/StatusPayment/PaymentPending';
import PaymentPendingSubscription from '../Pages/StatusPayment/PaymentPendingSubscription';


export default function Routeur () {
  return (
        <Routes>
            <Route path='' element={<Layouts/>}>
            <Route index element={<Home/>}/>
                <Route path='/subscription' element={<SubscriptionPack/>}/>
                <Route path='/inscription' element={<Inscription/>}/>
                <Route path='/login' element={<Login/>}/>
                <Route path='/shopping-cart' element={<ShoppingCart/>}/>
                <Route path="checkout_subscription/:id" element={<CheckoutSubscription />} />
                <Route path="checkout" element={<Checkout />} />
                <Route path='/apropos' element={<Apropos/>}/>
                <Route path='/contact' element={<Contact/>}/>
                <Route path='/course' element={<Course/>}/>
                <Route path='/detailcourse/:id' element={<DetailsCourse/>}/>
                <Route path='/dashboard' element={<DashboardPage/>}/>
                <Route path='/help' element={<HelpCenter/>}/>
                <Route path="condition/:id" element={<Condition />} />
                <Route path="/profile" element={<ComptClient />} />
                </Route>
                    <Route path="/payment-failure" element={<PaymentFailure />} />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                  <Route path="/payment-pending" element={<PaymentPending />} />
                  <Route path="/payment-pending-subscription" element={<PaymentPendingSubscription />} />
        </Routes>
  )
}
